import DataService from "@/services/DataService";

export default {
  getAll() {
    return DataService.apiClient.get("/roboter");
  },
  get(id) {
    return DataService.apiClient.get(`/roboter/${id}`);
  },
  createRoboterIDs() {
    return DataService.apiClient.get("/roboter/create/ids");
  },

  save(item) {
    //console.log(item);
    if (item._id != null) {
      return DataService.apiClient.patch(`/roboter/${item._id}`, item);
    } else {
      return DataService.apiClient.post("/roboter/", item);
    }
  },
  delete(id) {
    return DataService.apiClient.delete("/roboter/delete/" + id);
  }
};
